// Web v3 copy, canonical comp updated October 2, 2026.
// Outcome claims remain gated by existing authoritative state.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  "payments.title": "Payment setup",

  "payments.signedOut.refresh": "Your Stripe setup session expired.",
  "payments.signedOut.start": "Set up payments for your Lura account.",
  "payments.signedOut.resume":
    "Sign in to continue.",

  "payments.start.title": "Set up payments",
  "payments.start.sub": "",
  "payments.start.body": "Have your bank details and ID ready.",
  "payments.start.action": "Continue to Stripe",
  "payments.opening": "Opening payment setup…",
  "payments.openFailed": "We couldn’t open payment setup.",

  "payments.refresh.expired": "That Stripe link expired.",
  "payments.refresh.action": "Start again",

  "payments.complete.sub": "",
  "payments.complete.checking": "Checking your setup",

  "payments.ready": "Payment setup is ready",
  "payments.ready.hint": "",

  "payments.pending.line": "Stripe is reviewing your account.",
  "payments.pending.body": "",

  "payments.incomplete.line": "Finish your payment setup",
  "payments.incomplete.body": "",
  "payments.incomplete.action": "Finish on Stripe",

  "payments.denied.line": "Payments can’t be set up on this account.",
  "payments.denied.body": "",
  "payments.denied.action": "Get help",

  "payments.error.line": "Lura couldn’t check your setup.",
} as const;

export type PaymentsKey = keyof typeof en;

export const es: Partial<Record<PaymentsKey, string>> = {
  // These paragraphs are intentionally omitted in both locales; no translated prose.
  "payments.start.sub": "",
  "payments.complete.sub": "",
  "payments.ready.hint": "",
  "payments.pending.body": "",
  "payments.incomplete.body": "",
  "payments.denied.body": "",
  "payments.title": "Configuración de pagos",
  "payments.signedOut.refresh": "Venció tu sesión de configuración en Stripe.",
  "payments.signedOut.start": "Configura los pagos para tu cuenta de Lura.",
  "payments.start.title": "Configura los pagos",
  "payments.start.action": "Continuar a Stripe",
  "payments.openFailed": "No pudimos abrir la configuración de pagos.",
  "payments.refresh.expired": "Ese enlace de Stripe venció.",
  "payments.refresh.action": "Empezar de nuevo",
  "payments.pending.line": "Stripe está revisando tu cuenta.",
  "payments.incomplete.action": "Terminar en Stripe",
  "payments.denied.line": "No se pueden configurar los pagos en esta cuenta.",
  "payments.denied.action": "Obtener ayuda",
  "payments.complete.checking": "Verificando tu configuración",
  "payments.error.line": "Lura no pudo verificar tu configuración.",
  "payments.incomplete.line": "Termina de configurar los pagos",
  "payments.opening": "Abriendo la configuración de pagos…",
  "payments.ready": "La configuración de pagos está lista",
  "payments.signedOut.resume": "Inicia sesión para continuar.",
  "payments.start.body": "Ten a la mano tus datos bancarios y tu identificación.",
};
